import { Route } from '@angular/router';

import { APP_ROUTE_PATHS } from '@ps/core-config';

import { UnderConstructionPage } from '../pages/status-pages/under-construction/under-construction.page';
import {
  legacyUnderConstruction,
  UNDER_CONSTRUCTION_TITLE,
} from './utils/under-construction.helper';
import { numericParamGuard } from './utils/numeric-param.guard';
import { UserType } from '@ps/core-models';
import { roleGuard } from '@ps/user-settings-data-access';

function surveyUnderConstruction(path: string, legacyUrl: string): Route {
  return {
    path,
    component: UnderConstructionPage,
    canActivate: [numericParamGuard('id')],
    data: {
      legacyUrl,
    },
    title: UNDER_CONSTRUCTION_TITLE,
  };
}

// UPDATE THE ROUTES BELOW WHEN ADDING THE PAGE COMPONENTS

export const SURVEY_ROUTES: Route[] = [
  legacyUnderConstruction(APP_ROUTE_PATHS.createTemplate, '/create-templates'),
  legacyUnderConstruction(
    APP_ROUTE_PATHS.importDecipherSurvey,
    '/import-decipher-survey',
  ),
  legacyUnderConstruction(APP_ROUTE_PATHS.recontactSurvey, '/recontact-survey'),
  surveyUnderConstruction(APP_ROUTE_PATHS.manageSurvey, '/dashboard'),
];

/**
 * Survey workflow pages render their own page-specific navbar and have no sidebar,
 * so they're nested under `SurveyWorkflowLayoutComponent` in `app.routes.ts` instead
 * of the standard `AppLayoutComponent` shell that `SURVEY_ROUTES` above sits under.
 */
export const SURVEY_WORKFLOW_ROUTES: Route[] = [
  {
    path: APP_ROUTE_PATHS.createSurvey,
    loadComponent: () =>
      import('../pages/create-survey/create-survey.page').then(
        (m) => m.CreateSurveyPage,
      ),
    title: 'Create Survey',
    canActivate: [roleGuard],
    data: {
      roles: ['buyer'] as UserType[],
    },
  },
  {
    path: APP_ROUTE_PATHS.editSurvey,
    loadComponent: () =>
      import('../pages/edit-survey/edit-survey.page').then(
        (m) => m.EditSurveyPage,
      ),
    title: 'Edit Survey',
    canActivate: [numericParamGuard('id'), roleGuard],
    data: {
      roles: ['buyer'] as UserType[],
    },
  },
  surveyUnderConstruction(APP_ROUTE_PATHS.launchSurvey, '/dashboard'),
];
